import "./AjoutAdresse.scss";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCircleInfo, faPlus} from "@fortawesome/free-solid-svg-icons";
import React, {useState, useEffect} from "react";
import {useNavigate} from "react-router-dom";
import validator from "validator";
import NavBarProfil from "../../components/NavBarProfil/NavBarProfil";
import Swal from "sweetalert2";
import Cookies from "js-cookie";
import {Loader} from "../../utils/Loader";
import GoingBack from "../../components/GoingBack/GoingBack";
import AccountActiveOrNot from "../../components/AccountActiveOrNot/AccountActiveOrNot";
import TextAccountNotActiveWithDeconnectButton from "../../components/AccountActiveOrNot/TextAccountNotActiveWithDeconnectButton";

function AjoutAdresse() {
    const [nom, setNom] = useState("");
    const [prenom, setPrenom] = useState("");
    const [telephone, setTelephone] = useState("");
    const [codePostal, setCodePostal] = useState("");
    const [ville, setVille] = useState("");
    const [adresseForm, setAdresse] = useState("");
    const [complementAdresse, setComplementAdresse] = useState("");
    const [pays, setPays] = useState("");
    const [erreurInputAdresse, setErreurInputAdresse] = useState(null);
    const [erreurInputNom, setErreurInputName] = useState(null);
    const [erreurInputPrenom, setErreurInputPrenom] = useState(null);
    const [erreurInputTelephone, setErreurInputTelephone] = useState(null);
    const [erreurInputCodePostal, setErreurInputCodePostal] = useState(null);
    const [erreurInputVille, setErreurInputVille] = useState(null);
    const [erreurInputPays, setErreurInputPays] = useState(null);
    const [isDataLoading, setDataLoading] = useState(false);
    const [isBtnCliquer, setBtnCliquer] = useState(false);
    const navigate = useNavigate();
    const [accountActive, setAccountActive] = useState(null);

    const nameLengthVerif = () => nom.length > 0;
    const firstNameLengthVerif = () => prenom.length > 0;
    const villeVerif = () => ville.length > 0;
    const codePostalVerif = () => codePostal.length === 5 && validator.isInt(codePostal);
    const numeroTelVerif = () => validator.isMobilePhone(telephone) && telephone.length === 10;
    const paysVerif = () => pays.length > 0;
    const adresseVerif = () => adresseForm.length > 0;

    const checkFormValidity = () => {
        return (
            numeroTelVerif() &&
            firstNameLengthVerif() &&
            nameLengthVerif() &&
            villeVerif() &&
            codePostalVerif() &&
            paysVerif() &&
            adresseVerif()
        );
    };

    useEffect(() => {
        if (!isBtnCliquer) return;
        
        const handleClickCreateAdresse = async () => {
            if (checkFormValidity()) {
                const adresse = {
                    nomPersonne: nom,
                    prenomPersonne: prenom,
                    adresse: adresseForm,
                    codePostal: codePostal,
                    ville: ville,
                    complementAdresse: complementAdresse,
                    pays: pays,
                    numTel: telephone
                };
                try {
                    setDataLoading(true)
                    const response = await fetch(
                        `${process.env.REACT_APP_API_URL}adresses/insert`,
                        {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: `Bearer ${Cookies.get("auth_token")}`,
                            },
                            body: JSON.stringify(adresse),
                        }
                    );
                    if (response.ok) {
                        Swal.fire({
                            text: "Adresse créée avec succès !",
                            icon: "success",
                            toast: true,
                            position: "top-end",
                            showConfirmButton: false,
                            timer: 3000,
                            timerProgressBar: true,
                            customClass: {
                                timerProgressBar: "background-color: #5b7f50 !important",
                            }
                        }).then(() => {
                            navigate(-1);
                        });
                    } else {
                        Swal.fire({
                            text: "L'adresse n'a pas pu être créée.",
                            icon: "error",
                            toast: true,
                            position: "top-end",
                            showConfirmButton: false,
                            timer: 3000
                        });
                    }
                } catch (error) {
                    console.error("Erreur de connexion au serveur:", error);
                    Swal.fire({
                        text: "Erreur réseau.",
                        icon: "error",
                        toast: true,
                        position: "top-end",
                        showConfirmButton: false,
                        timer: 3000
                    });
                } finally {
                    setDataLoading(false);
                    setBtnCliquer(false);
                }
            } else {
                Swal.fire({
                    text: "Veuillez remplir correctement tous les champs obligatoires.",
                    icon: "warning"
                });
                !numeroTelVerif() ? setErreurInputTelephone("Format numéro de téléphone incorrect") : setErreurInputTelephone(null);
                !firstNameLengthVerif() ? setErreurInputPrenom("Prénom non renseigné") : setErreurInputPrenom(null);
                !nameLengthVerif() ? setErreurInputName("Nom non renseigné") : setErreurInputName(null);
                !villeVerif() ? setErreurInputVille("Ville non renseignée") : setErreurInputVille(null);
                !codePostalVerif() ? setErreurInputCodePostal("Code postal non valide") : setErreurInputCodePostal(null);
                !paysVerif() ? setErreurInputPays("Pays non renseigné") : setErreurInputPays(null);
                !adresseVerif() ? setErreurInputAdresse("Adresse non renseignée") : setErreurInputAdresse(null);
                setBtnCliquer(false);
            }
        }
        handleClickCreateAdresse();
    }, [isBtnCliquer])

    const handleBlurNameLength = () => {
        if (nom.length === 0) setErreurInputName("Renseignez un nom s'il vous plaît");
        else setErreurInputName(null);
    };

    const handleBlurFirstNameLength = () => {
        if (prenom.length === 0) setErreurInputPrenom("Renseignez un prénom s'il vous plaît");
        else setErreurInputPrenom(null);
    };

    const handleBlurPays = () => {
        if (pays.length === 0) setErreurInputPays("Pays non valide");
        else setErreurInputPays(null);
    };

    const handleBlurTel = () => {
        if (!numeroTelVerif()) setErreurInputTelephone("Numéro de téléphone incorrect");
        else setErreurInputTelephone(null);
    };

    const handleBlurVille = () => {
        if (ville.length === 0) setErreurInputVille("Ville non valide");
        else setErreurInputVille(null);
    };

    const handleBlurCodePostal = () => {
        if (!codePostalVerif()) setErreurInputCodePostal("Code postal non valide");
        else setErreurInputCodePostal(null);
    };

    const handleBlurAdresse = () => {
        if (adresseForm.length === 0) setErreurInputAdresse("Adresse non valide");
        else setErreurInputAdresse(null);
    };

    return (
        <>
            <AccountActiveOrNot setAccountActive={setAccountActive}/>
            {accountActive === false && accountActive !== null ? (
                <TextAccountNotActiveWithDeconnectButton/>
            ) : (
                <div className="div-main-ajout-adresse">
                    <NavBarProfil />
                    <div className="div-infos-adresse">
                        <GoingBack />
                        <h1>Ajouter une adresse</h1>
                        
                        <div className="infos-details-adresse">
                            <div className="container-adresse-left">
                                <div className="div-input-register">
                                    <label>Adresse postale</label>
                                    <input
                                        className="input-login"
                                        value={adresseForm}
                                        placeholder="Numéro et nom de rue"
                                        onBlur={handleBlurAdresse}
                                        onChange={(e) => setAdresse(e.target.value)}
                                    />
                                    {erreurInputAdresse && !adresseVerif() &&
                                        <div className="div-error-message-register">
                                            <FontAwesomeIcon id="icon-infos-error" icon={faCircleInfo} />
                                            <p>{erreurInputAdresse}</p>
                                        </div>
                                    }
                                </div>
                                <div className="div-input-register">
                                    <label>Complément d'adresse (optionnel)</label>
                                    <input
                                        className="input-login"
                                        value={complementAdresse}
                                        placeholder="Bâtiment, étage, digicode..."
                                        onChange={(e) => setComplementAdresse(e.target.value)}
                                    />
                                </div>
                                <div className="div-input-register">
                                    <label>Code postal</label>
                                    <input
                                        className="input-login"
                                        value={codePostal}
                                        placeholder="Ex: 75001"
                                        onBlur={handleBlurCodePostal}
                                        onChange={(e) => setCodePostal(e.target.value)}
                                    />
                                    {erreurInputCodePostal && !codePostalVerif() &&
                                        <div className="div-error-message-register">
                                            <FontAwesomeIcon id="icon-infos-error" icon={faCircleInfo} />
                                            <p>{erreurInputCodePostal}</p>
                                        </div>
                                    }
                                </div>
                                <div className="div-input-register">
                                    <label>Ville</label>
                                    <input
                                        className="input-login"
                                        value={ville}
                                        placeholder="Ex: Paris"
                                        onBlur={handleBlurVille}
                                        onChange={(e) => setVille(e.target.value)}
                                    />
                                    {erreurInputVille && !villeVerif() &&
                                        <div className="div-error-message-register">
                                            <FontAwesomeIcon id="icon-infos-error" icon={faCircleInfo} />
                                            <p>{erreurInputVille}</p>
                                        </div>
                                    }
                                </div>
                                <div className="div-input-register">
                                    <label>Pays</label>
                                    <input
                                        className="input-login"
                                        value={pays}
                                        placeholder="Ex: France"
                                        onBlur={handleBlurPays}
                                        onChange={(e) => setPays(e.target.value)}
                                    />
                                    {erreurInputPays && !paysVerif() &&
                                        <div className="div-error-message-register">
                                            <FontAwesomeIcon id="icon-infos-error" icon={faCircleInfo} />
                                            <p>{erreurInputPays}</p>
                                        </div>
                                    }
                                </div>
                            </div>
                            
                            <div className="div-infos-perso">
                                <div className="div-input-register">
                                    <label>Nom de famille</label>
                                    <input
                                        className="input-login"
                                        placeholder="Votre nom"
                                        value={nom}
                                        onBlur={handleBlurNameLength}
                                        onChange={(e) => setNom(e.target.value)}
                                    />
                                    {erreurInputNom && !nameLengthVerif() &&
                                        <div className="div-error-message-register">
                                            <FontAwesomeIcon id="icon-infos-error" icon={faCircleInfo} />
                                            <p>{erreurInputNom}</p>
                                        </div>
                                    }
                                </div>
                                <div className="div-input-register">
                                    <label>Prénom</label>
                                    <input
                                        className="input-login"
                                        placeholder="Votre prénom"
                                        value={prenom}
                                        onBlur={handleBlurFirstNameLength}
                                        onChange={(e) => setPrenom(e.target.value)}
                                    />
                                    {erreurInputPrenom && !firstNameLengthVerif() &&
                                        <div className="div-error-message-register">
                                            <FontAwesomeIcon id="icon-infos-error" icon={faCircleInfo} />
                                            <p>{erreurInputPrenom}</p>
                                        </div>
                                    }
                                </div>
                                <div className="div-input-register">
                                    <label>Numéro de téléphone</label>
                                    <input
                                        className="input-login"
                                        placeholder="Ex: 0612345678"
                                        value={telephone}
                                        onBlur={handleBlurTel}
                                        onChange={(e) => setTelephone(e.target.value)}
                                    />
                                    {erreurInputTelephone && !numeroTelVerif() &&
                                        <div className="div-error-message-register">
                                            <FontAwesomeIcon id="icon-infos-error" icon={faCircleInfo} />
                                            <p>{erreurInputTelephone}</p>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                        
                        {isDataLoading ? (
                            <div style={{display: 'flex', justifyContent: 'center', marginTop: '2rem'}}>
                                <Loader />
                            </div>
                        ) : (
                            <button className="btn-save" onClick={() => setBtnCliquer(true)}>
                                Ajouter l'adresse
                                <FontAwesomeIcon icon={faPlus} className="icon-signIn"/>
                            </button>
                        )}
                    </div>
                </div>
            )}
        </>
    );
}

export default AjoutAdresse;
